import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from 'angular';
import AuthDataServiceName, {AuthDataService} from "../auth/authData.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import DefectServiceName, {DefectService} from "./defect.service";
import NotifyServiceName, {NotifyService} from "../notify/notify.service";
import CheckListReportDetailsName, {openCheckListReportDetails} from "../../controllers/checkLists/checkListReportDetails.controller";
import FillOutCheckListName, {openFillOutCheckList} from "../../controllers/checks/fillOutCheckList.controller";

let requires = [AuthDataServiceName, LoaderServiceName, DefectServiceName, NotifyServiceName,
  CheckListReportDetailsName, FillOutCheckListName];

export interface CriticalDefectService {
  openReport(shopId: string,
             defect: {id: string, timeFound: Date}): angular.IPromise<apsViewModels.DefectCriticalReportDetails>;
}

export default angular
  .module('aps.services.criticalDefects', requires)
  .service('criticalDefectService', (
    authDataService: AuthDataService,
    loaderService: LoaderService,
    defectService: DefectService,
    notifyService: NotifyService,
    $modal: mm.foundation.modal
  ): CriticalDefectService => {
    let openReport = (shopId: string,
                      defect: {id: string, timeFound: Date}) => {
      let roleId = authDataService.getSelectedRoleLocation().role.roleId;
      let promise = defectService.getCriticalDefectReportDetails(defect.id, shopId, roleId, defect.timeFound);

      promise.then((data: apsViewModels.DefectCriticalReportDetails) => {
        if (!data) {
          notifyService.error('Could not find Critical Defect Report for this defect');
          return;
        }

        if (data.fillOut) {
          openFillOutCheckList({
            checkListId: data.checkListId,
            instanceId: data.instanceId,
            shopId: data.shopId,
            plantId: data.plantId,
            tankId: data.tankId,
            plantLocationId: data.plantLocationId,
            scheduledOn: data.scheduledOn
          }, $modal);
        } else {
          openCheckListReportDetails({
            checkListInstance: data.reportDetails.reportItem,
            detail: data.reportDetails
          }, $modal);
        }
      });
      loaderService.loadingPromise(promise);
      return promise;
    };

    return {
      openReport: openReport
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/defects/criticalDefectService.ts